import { cn } from "@/domains/library"

export const ScaleInnerCard300 = ({
  children,
  className,
  onClick,
  style,
  enabled = false,
}: {
  children: React.ReactNode
  className?: string
  enabled?: boolean
  style?: React.CSSProperties
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (onClick) {
      onClick(event)
    }
  }
  const s: React.CSSProperties = {
    opacity: 0.7,
    ...style,
  }
  if (enabled === true) {
    s.opacity = 1
  }

  return (
    <div
      className={cn(
        "sc-inner-card-300",
        "rounded-lg",
        "transition-all duration-300 ease-in-out",
        "border",
        enabled ? "bg-p300 hover:bg-p300-light" : "bg-p300-shade hover:bg-p300",
        enabled ? "border-p300-shade" : "border-p300-light",
        className,
      )}
      data-enabled={enabled ? "true" : "false"}
      style={s}
      onClick={handleClick}
    >
      {children}
    </div>
  )
}
